const maxRadius = 100000;

export const logaritRadiusMarkMap = (value) => {
    const radius = (Math.log(value + 1) / Math.log(1000000 + 1)) * maxRadius;
    return radius;
};
